import {Action} from '@reduxjs/toolkit'
import moment from 'moment'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import {ViewTypes, weeklyOptions} from '../enums'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetOccupancyFilters: '[Reports SetOccupancyFilters] Action',
  SetAssetUsageFilters: '[Reports SetAssetUsageFilters] Action',
}

const initialReportsState: IReportsState = {
  occupancy: {
    start: moment().format('YYYY-MM-DD'),
    end: moment().add(1, 'M').format('YYYY-MM-DD'),
    view: {value: ViewTypes.Monthly, label: 'Monthly'},
    showWeekends: false,
    weeks: weeklyOptions[0],
    site: null,
  },
  assetUsage: {
    start: moment().format('YYYY-MM-DD'),
    end: moment().add(1, 'M').format('YYYY-MM-DD'),
    view: {value: ViewTypes.Monthly, label: 'Monthly'},
    showWeekends: false,
    weeks: weeklyOptions[0],
    site: null,
    floor: null,
    zone: null,
    assetType: null,
  },
}

export interface IOccupancyFilters {
  start: string
  end: string
  view: {value: number; label: string}
  showWeekends: boolean
  weeks: {value: number; label: string}
  site: any
}

export interface IAssetUsageFilters {
  start: string
  end: string
  view: {value: number; label: string}
  showWeekends: boolean
  weeks: {value: number; label: string}
  site: any
  floor: any
  zone: any
  assetType: any
}

export interface IReportsState {
  occupancy: IOccupancyFilters
  assetUsage: IAssetUsageFilters
}

export const reducer = persistReducer(
  {storage, key: 'v100-Reports', whitelist: ['occupancy', 'assetUsage']},
  (state: IReportsState = initialReportsState, action: ActionWithPayload<any>) => {
    switch (action.type) {
      case actionTypes.SetOccupancyFilters: {
        const filters = action.payload?.filters
        return {...state, occupancy: {...state.occupancy, ...filters}}
      }
      case actionTypes.SetAssetUsageFilters: {
        const filters = action.payload?.filters
        return {...state, assetUsage: {...state.assetUsage, ...filters}}
      }
      default:
        return state
    }
  }
)

export const Actions = {
  setOccupancyFilters: (filters: Partial<IOccupancyFilters>) => ({
    type: actionTypes.SetOccupancyFilters,
    payload: {filters},
  }),
  setAssetUsageFilters: (filters: Partial<IAssetUsageFilters>) => ({
    type: actionTypes.SetAssetUsageFilters,
    payload: {filters},
  }),
}
